import getIn from 'transmute/getIn';
import { TYPE } from '../../common-message-format/constants/keyPaths';
import { UNSUPPORTED_CONTENT } from '../../common-message-format/constants/attachmentTypes';
import { getAttachments } from '../../common-message-format/operators/getAttachments';
export const isUnsupportedContentAttachment = attachment => getIn(TYPE, attachment) === UNSUPPORTED_CONTENT;
export const getUnsupportedContentAttachment = message => {
  const attachments = getAttachments(message);
  if (!attachments || attachments.size === 0) return null;
  return attachments.find(isUnsupportedContentAttachment) || null;
};